import { render, staticRenderFns } from "./Precios.vue?vue&type=template&id=7ff38e2a&scoped=true"
import script from "./Precios.vue?vue&type=script&setup=true&lang=js"
export * from "./Precios.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Precios.vue?vue&type=style&index=0&id=7ff38e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff38e2a",
  null
  
)

export default component.exports